import { ITaskAssignee } from "@/data/tasks/types";

export const isAssigneeAccountNotDeleted = (assignee: ITaskAssignee | undefined) =>
  assignee && !["DELETED", "DEACTIVATED"].includes(assignee.status);
